import { isAdminLoggedIn } from "../../Panel/index";
import { allfilterI, columnInterface, lastFeedsActivitiesI, selectOptionsI } from "./Interface";

export const gridFilters: allfilterI = {
    'Source Order Id': {
        value: 'source_order_id',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Container_id': {
        value: 'container_id',
        textValue: '',
        type: "",
        searchvalue: "",
        selectValue: '1',
        change: false,
    },
    'Target Order Id': {
        value: 'target_order_id',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Source Status': {
        value: 'source_status',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Target Status': {
        value: 'target_status',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    title: {
        value: 'title',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    label: {
        value: 'assigned_labels.id',
        textValue: '',
        selectValue: '10',
        change: false,
    },
    variant_title: {
        value: 'items.variant_title',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    // gridTitle: {
    //     value: 'items.title',
    //     textValue: '',
    //     selectValue: '3',
    //     change: false,
    // },
    Inventory: {
        value: 'items.quantity',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    SKU: {
        value: 'cif_amazon_multi_sku',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    Tags: {
        value: 'tags',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Product type': {
        value: 'product_type',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Barcode': {
        value: 'Barcode',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Barcode Exists': {
        value: 'cif_amazon_multi_barcode_exists',
        textValue: '',
        selectValue: '12',
        change: false,
    },
    Vendor: {
        value: 'brand',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    "Vendor multi": {
        value: 'brand',
        textValue: '',
        selectValue: '10',
        change: false,
    },
    'Template name': {
        value: 'cif_amazon_multi_template_id',
        label: '',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    'Template name multi': {
        value: 'cif_amazon_multi_template_id_multi',
        label: '',
        textValue: '',
        selectValue: '10',
        change: false,
    },
    'Product Status': {
        value: 'items.status',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    'Variant attributes': {
        value: 'cif_amazon_multi_variant_attributes',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    Activity: {
        value: 'cif_amazon_multi_activity',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    Type: {
        value: 'type',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    Error: {
        value: "items.error.code",
        textValue: '',
        errorName: "",
        selectValue: '1',
        change: false,
    },
    error_message: {
        value: "items.error.message",
        textValue: '',
        errorName: "",
        selectValue: '3',
        change: false,
    },
    "Duplicate SKU": {
        value: 'items.duplicate_sku',
        change: false,
        textValue: '',
        selectValue: '1'
    },
    "variant query": {
        value: 'cif_amazon_multi_sku',
        change: false,
        textValue: '',
        selectValue: '3'
    },
    'Fulfilment Type': {
        value: 'items.fulfillment_type',
        textValue: '',
        selectValue: '1',
        change: false
    },
    'Amazon Recommended Product Type': {
        value: 'items.amazonProductType',
        textValue: '',
        selectValue: '1',
        change: false
    }
}

export const gridFiltersVariation: allfilterI = {
    'Source Order Id': {
        value: 'source_order_id',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Container_id': {
        value: 'container_id',
        textValue: '',
        type: "",
        searchvalue: "",
        selectValue: '1',
        change: false,
    },
    'Target Order Id': {
        value: 'target_order_id',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Source Status': {
        value: 'source_status',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Target Status': {
        value: 'target_status',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    title: {
        value: 'title',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    label: {
        value: 'assigned_labels.id',
        textValue: '',
        selectValue: '10',
        change: false,
    },
    variant_title: {
        value: 'items.variant_title',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    // gridTitle: {
    //     value: 'items.title',
    //     textValue: '',
    //     selectValue: '3',
    //     change: false,
    // },
    Inventory: {
        value: 'items.quantity',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    SKU: {
        value: 'cif_amazon_multi_sku',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    Tags: {
        value: 'tags',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Product type': {
        value: 'product_type',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Barcode': {
        value: 'Barcode',
        textValue: '',
        selectValue: '3',
        change: false,
    },
    'Barcode Exists': {
        value: 'cif_amazon_multi_barcode_exists',
        textValue: '',
        selectValue: '12',
        change: false,
    },
    Vendor: {
        value: 'brand',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    "Vendor multi": {
        value: 'brand',
        textValue: '',
        selectValue: '10',
        change: false,
    },
    'Template name': {
        value: 'cif_amazon_multi_template_id',
        label: '',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    'Template name multi': {
        value: 'cif_amazon_multi_template_id_multi',
        label: '',
        textValue: '',
        selectValue: '10',
        change: false,
    },
    'Product Status': {
        value: 'items.status',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    'Variant attributes': {
        value: 'cif_amazon_multi_variant_attributes',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    Activity: {
        value: 'cif_amazon_multi_activity',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    Type: {
        value: 'type',
        textValue: '',
        selectValue: '1',
        change: false,
    },
    Error: {
        value: "items.error.code",
        textValue: '',
        errorName: "",
        selectValue: '1',
        change: false,
    },
    error_message: {
        value: "items.error.message",
        textValue: '',
        errorName: "",
        selectValue: '3',
        change: false,
    },
    "Duplicate SKU": {
        value: 'items.duplicate_sku',
        change: false,
        textValue: '',
        selectValue: '1'
    },
    "variant query": {
        value: 'cif_amazon_multi_sku',
        change: false,
        textValue: '',
        selectValue: '3'
    },
    'Fulfilment Type': {
        value: 'items.fulfillment_type',
        textValue: '',
        selectValue: '1',
        change: false
    },
    'Amazon Recommended Product Type': {
        value: 'items.amazonProductType',
        textValue: '',
        selectValue: '1',
        change: false
    }
}


export const gridColumns = (t: any): columnInterface => [
    {
        title: t('Image'),
        dataIndex: 'image',
        align: 'left',
        width: '90px',
    },
    {
        title: t('Title'),
        dataIndex: 'title',
        align: 'left',
        width: '180px',
    },
    {
        title: t('SKU'),
        dataIndex: 'sku',
        align: 'left',
        width: '220px',
    },
    {
        title: t('Product Details'),
        dataIndex: 'productDetails',
        align: 'left',
        width: '200px',
    },
    {
        title: t('Template'),
        dataIndex: 'template',
        align: 'left',
        width: '180px',
    },
    ...(isAdminLoggedIn() || process.env.REACT_APP_PROD === "0") ? [{
        title: 'Label',
        dataIndex: 'label',
        align: 'left',
        width: '180px',
    }] : [],
    {
        title: t('Inventory'),
        dataIndex: 'quantity',
        align: 'left',
        width: ' 100px',
    },
    {
        title: t('Variants'),
        dataIndex: 'variants',
        align: 'left',
        width: ' 120px',
    },
    {
        title: t('Amazon Status'),
        dataIndex: 'status',
        align: 'center',
        width: '130px',
    },
    {
        title: t('Activity'),
        dataIndex: 'activity',
        align: 'center',
        width: '150px',
    },
    {
        title: t('Feed'),
        dataIndex: 'feed',
        align: 'center',
        width: '70px',
    },
    {
        title: t('Actions'),
        dataIndex: 'action',
        align: 'left',
        width: '90px',
        fixed:"right"
    },
]

export const variantGridCols = (t: any): columnInterface => [
    {
        title: t('Image'),
        dataIndex: 'image',
        width: '10px'
    },
    {
        title: t('SKU'),
        dataIndex: 'sku',
        width: "100px"
    },
    {
        title: t('Product Details'),
        dataIndex: 'productDetails',
        align: 'left',
        width: '130px',
    },
    {
        title: t('Inventory'),
        dataIndex: 'quantity',
        width: '50px',
    },
    {
        title: t("Amazon Status"),
        dataIndex: 'status',
        width: '100px',
    },
    {
        title: t("Activity"),
        dataIndex: 'activity',
        align: 'center',
        width: '110px',
    },
    {
        title: t('Feed'),
        dataIndex: 'feed',
        align: 'center',
        width: '70px',
    }
]

export const LastFeedActivitiesCols = (t: any): lastFeedsActivitiesI[] => [
    {
        title: t('Feed Type'),
        dataIndex: 'type',
        key: 'feed',
        width: '100px'
    },
    {
        title: t('Date'),
        dataIndex: 'updated_at',
        key: 'date',
        width: '100px'
    },
    // {
    //     title: t('Status'),
    //     dataIndex: 'status',
    //     key: 'status',
    //     width: '100px'
    // }
]

export const filterKeySelect = (t: any): selectOptionsI[] =>
    [
        { label: t('Equals'), value: '1', code: 'Equals' },
        { label: t('Not Equals'), value: '2', code: "Not Equals" },
        { label: t('Greater Than or Equal to'), value: '8', code: 'Greater Than or Equal to' },
        { label: t('Less Than or Equal to'), value: '9', code: 'Less Than or Equal to' },
        // { label: t('Contains'), value: '10', code: 'Less Than or Equal to' },
    ]


export const filterKeySelectTemplate = (t: any): selectOptionsI[] =>
    [
        { label: t('Equals'), value: '1', code: 'Equals' },
        { label: t('Not Equals'), value: '2', code: "Not Equals" },
        { label: t('Greater Than or Equal to'), value: '8', code: 'Greater Than or Equal to' },
        { label: t('Less Than or Equal to'), value: '9', code: 'Less Than or Equal to' },
        { label: t('Contains'), value: '10', code: 'Less Than or Equal to' },
    ]


export const optionsSKUSelect = (t: any): selectOptionsI[] => [
    { label: t('Equals'), value: '1' },
    { label: t('Not Equals'), value: '2' },
    { label: t('Contains'), value: '3' },
    { label: t('Does not Contains'), value: '4' },
    { label: t('Starts With'), value: '5' },
    { label: t('Ends With'), value: '6' },
];
export const optionsSKUSelect123: selectOptionsI[] = [
    { label: 'Equals', value: '1' },
    { label: 'Not Equals', value: '2' },
    { label: 'Contains', value: '3' },
    { label: 'Does not Contains', value: '4' },
    { label: 'Starts With', value: '5' },
    { label: 'Ends With', value: '6' },
];

export const optionForVendor = (t: any): selectOptionsI[] => [
    { label: t('Equals'), value: '1' },
    { label: t('Not Equals'), value: '2' },
];

export const Type = (t: any): selectOptionsI[] => [
    { label: t('simple'), value: '1', code: "simple" },
    { label: t('variation'), value: '2', code: "variation" },
];

export const fulfillmentTypeOptions = (t: any): selectOptionsI[] => [
    { label: t('FBM'), value: 'FBM', code: "FBM" },
    { label: t('FBA'), value: 'FBA', code: "FBA" },
];

export const status = (t: any): selectOptionsI[] => [
    { label: t('Active'), value: 'Active', code: 'Active' },
    { label: t('Uploaded'), value: 'Uploaded', code: 'Uploaded' },
    { label: t('Not Listed'), value: 'Not Listed', code: 'Not Listed' },
    { label: t('Inactive'), value: 'Inactive', code: 'Inactive' },
    { label: t('Incomplete'), value: 'Incomplete', code: 'Incomplete' },
    { label: t('Not Listed: Offer'), value: 'Not Listed: Offer', code: 'Not Listed: Offer' },
];

export const Activity = (t: any): selectOptionsI[] => [
    { label: t('In Progress'), value: 'process_tags' },
    { label: t('Error'), value: 'error' },
    { label: t('Warning'), value: 'warning' },
];

export const AIEnabled: selectOptionsI[] = [
    { label: 'Optimized', value: 'true' },
    { label: 'Not Optimized', value: 'false' },
];

export const barcodeExist: selectOptionsI[] = [
    { label: 'True', value: "1", code: "True" },
    { label: "False", value: "0 ", code: "False" },
];

export const apiData: any = {
    "_id": 1,
    "container_id": 1,
    "source_product_id": 1,
    "source_shop_id": 1,
    "target_shop_id": 1,
    "user_id": 1,
    "brand": 1,
    "status": {
        "$map": {
            "input": "$items",
            "as": "item",
            "in": "$$item.status"
        }
    },
    "items": {
        "$filter": {
            "input": "$items",
            "as": "item",
            "cond": {
                "$eq": ["$source_product_id", "$$item.source_product_id"]
            }
        }
    },
    "assigned_labels": 1,

    // "items": 1,
    "main_image": 1,
    "label":1,
    "product_type": 1,
    "tags": 1,
    "target_product_id": 1,
    "title": 1,
    "type": 1,
    "updated_at": 1,
    "variant_attributes": 1,
    "profile": 1,
    "variant_count": {
        "$size": "$items"  // Count the number of items
    },
    "quantity": {
        "$sum": {
            "$map": {
                "input": "$items",
                "as": "item",
                "in": "$$item.quantity"
            }
        }
    },
    "has_flags": {
        "has_error": {
            "$anyElementTrue": {
                "$map": {
                    "input": "$items",
                    "as": "item",
                    "in": {
                        "$cond": { "if": { "$ne": [{ "$type": "$$item.error" }, "missing"] }, "then": true, "else": false }
                    }
                }
            }
        },
        "has_progress": {
            "$anyElementTrue": {
                "$map": {
                    "input": "$items",
                    "as": "item",
                    "in": {
                        "$cond": { "if": { "$ne": [{ "$type": "$$item.process_tags" }, "missing"] }, "then": true, "else": false }
                    }
                }
            }
        },
        "has_warning": {
            "$anyElementTrue": {
                "$map": {
                    "input": "$items",
                    "as": "item",
                    "in": {
                        "$cond": { "if": { "$ne": [{ "$type": "$$item.warning" }, "missing"] }, "then": true, "else": false }
                    }
                }
            }
        }
    }
};




// export const apiData: string[] = [
//     "_id",
//     "container_id",
//     "source_product_id",
//     "source_shop_id",
//     "target_shop_id",
//     "user_id",
//     "brand",
//     'items': {$filter: {input: "$items",as: "item",cond: {$eq: ["$source_product_id", "$$item.source_product_id"]}}
//     // "items.shop_id",
//     // "items.source_product_id",
//     // "items.title",
//     // "items.variant_title",
//     // "items.sku",
//     // "items.main_image",
//     // "items.target_marketplace",
//     // "items.quantity",
//     // "items.price",
//     // "items.barcode",
//     // "items.variant_title",
//     // "items.error",
//     // "items.warning",
//     // "items.status",
//     // "items.process_tags",
//     // "items.isAiEnable",
//     // "items.asin",
//     "status",
//     "main_image",
//     "product_type",
//     "tags",
//     "target_product_id",
//     "title",
//     "type",
//     "updated_at",
//     "variant_attributes",
//     "profile"
// ]

export const previewModalTabs = (t: any) => [
    {
        id: 'amazon_preview',
        content: t('Amazon Preview'),
        accessibilityLabel: 'Amazon Preview',
    },
    {
        id: 'tabular_preview',
        content: t('JSON Preview'),
        accessibilityLabel: 'Tabular Preview',
    },
]